// extracted by mini-css-extract-plugin
module.exports = {"container":"CountdownTimer_container__j8JZ2","text":"CountdownTimer_text__m11Q8","finished":"CountdownTimer_finished__QSvtl","flash":"CountdownTimer_flash__5NGrZ"};